module.exports = __webpack_public_path__ + "static/img/linzengxiang.46ce189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linzengxiang.png
// module id = Q5ZM
// module chunks = 1